import React from 'react';
import { UPDATE_FLASH_MESSAGE, RESET_FLASH_MESSAGE } from '../actionTypes';

const initialState = {
  open: false,
  message: '',
  severity: 'success',
  icon: undefined,
  primaryAction: undefined,
  secondaryAction: undefined,
};

interface StateType {
  open: boolean;
  severity: string;
  message: string;
  icon?: React.ReactNode | undefined;
  primaryAction?: {
    label: string;
    onClick: () => void;
  };
  secondaryAction?: {
    label: string;
    onClick: () => void;
  };
}

interface Action {
  type: string;
  payload: StateType;
}

const flashMessage = (flashMessage = initialState, action: Action): StateType => {
  switch (action.type) {
    case UPDATE_FLASH_MESSAGE:
      return action.payload;
    case RESET_FLASH_MESSAGE:
      return initialState;

    default:
      return flashMessage;
  }
};

export default flashMessage;
